import { accountManagerController } from "./\bAccountManager/AccountmanagerController";
import { contractController } from "./Contract/ContractController";
import { currencyController } from "./Currency/CurrencyController";
import { metadataManagerController } from "./MetadataManager/MetadataManagerController";
import { microChainController } from "./MicroChain/MicroChainController";
import { myKitsController } from "./My-Kits/MyKitsController";
import { nftKitsController } from "./NFT-Kits/NFTKitsController";
import { projectController } from "./Project/ProjectController";
import { requestController } from "./Request/RequestController";
import { tokenKitsController } from "./Token-Kits/TokenKitsController";
import { walletController } from "./Wallet/WalletController";
import { webhookController } from "./Webhook/WebhookController";

export const controllers = {
  microChain: microChainController,
  wallet: walletController,
  request: requestController,
  tokenKits: tokenKitsController,
  currency: currencyController,
  contract: contractController,
  project: projectController,
  accountManager: accountManagerController,
  webhook: webhookController,
  nftKits: nftKitsController,
  myKits: myKitsController,
  metadataManager: metadataManagerController,
};
